export default __webpack_public_path__ + "static/media/logo_index.5cf4b7c2.jpeg";